import { render, staticRenderFns } from "./MfaLogin.vue?vue&type=template&id=efb1e70c&scoped=true&"
import script from "./MfaLogin.vue?vue&type=script&lang=ts&"
export * from "./MfaLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb1e70c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efb1e70c')) {
      api.createRecord('efb1e70c', component.options)
    } else {
      api.reload('efb1e70c', component.options)
    }
    module.hot.accept("./MfaLogin.vue?vue&type=template&id=efb1e70c&scoped=true&", function () {
      api.rerender('efb1e70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/auth/MfaLogin.vue"
export default component.exports